import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RiCloseFill } from "react-icons/ri";
import { utils } from "helper";


const NewRole = ({
  roleModules,
  setRoleModules,
  loading = false,
  handleSubmit,
}) => {
  let moduleObjectId = '675c17752cfe4271751f1ce1';
  let paymentApvObjectId = '675c1a4a2cfe4271751f1ce7';
  const navigate = useNavigate();
  // const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null)
  const location = useLocation();
  const isViewPage = location.pathname.startsWith('/setting/role/view');
  const [paymentApproval, setPaymentApproval] = useState([]);
  const [isPaymentApproval, setIsPaymentApproval] = useState(false);
  const [open, setOpen] = useState({ key: false, label: '', index: -1 });

  const handlePermissionChange = (moduleId, childId, key, permIndex, value) => {
    setRoleModules((prevModules) => {
      return prevModules.map((module) => {
        if (module._id === moduleId) {
          return {
            ...module,
            children: module.children.map((child) => {
              if (child._id === childId) {
                const updatedChild = { ...child };

                if (key === "more_permissions" && permIndex !== undefined) {
                  const updatedMorePermissions = [...updatedChild.more_permissions];

                  // Update the permission's is_enabled value
                  updatedMorePermissions[permIndex] = {
                    ...updatedMorePermissions[permIndex],
                    is_enabled: value,
                  };

                  updatedChild.more_permissions = updatedMorePermissions;
                }
                // Optionally: update full_access or other keys here if needed

                return updatedChild;
              }
              return child;
            }),
          };
        }
        return module;
      });
    });
  };

  const handleChange = (moduleId, childId, key, value) => {
    setRoleModules((prevModules) => {
      let data = prevModules.map((module) => {
        if (module._id === moduleId) {
          return {
            ...module,
            children: module.children.map((child) => {
              if (child._id === childId) {
                const updatedChild = { ...child };

                if (key === "full_access") {
                  updatedChild.full_access = value;
                  updatedChild.view = updatedChild?.view != 0 ? value : 0;
                  updatedChild.create = updatedChild?.create != 0 ? value : 0;
                  updatedChild.edit = updatedChild?.edit != 0 ? value : 0;
                  updatedChild.delete = updatedChild?.delete != 0 ? value : 0;
                } else {
                  updatedChild[key] = value;
                  if (key === "view") {
                    updatedChild.view = value;
                  } else {
                    const keysToCheck = ["edit", "create", "delete"];
                    const hasAnyPermission = keysToCheck.some(
                      (perm) => updatedChild[perm] === 1
                    );
                    updatedChild.view = hasAnyPermission ? 1 : 2;
                  }
                }

                const keysToCheck = ["view", "create", "edit", "delete"];

                const filteredKeys = keysToCheck.filter(
                  (key) => updatedChild[key] !== 0
                );

                const allPermissionsChecked = filteredKeys.every(
                  (key) => updatedChild[key] === 1
                );

                updatedChild.full_access = allPermissionsChecked ? 1 : 2;
                return updatedChild;
              }
              return child;
            }),
          };
        }
        return module;
      });
      return data;
    });
  };


  const handleParentCheckbox = (moduleId, isChecked, moduleLabel) => {
    setRoleModules((prevModules) =>
      prevModules.map((module) => {
        if (module._id === moduleId) {
          return {
            ...module,
            web: module?.web !== 0 ? (isChecked ? 1 : 2) : 0,
            mobile: module?.mobile !== 0 ? (isChecked ? 1 : 2) : 0,
            children: module.children.map((child) => {
              // Check if the moduleLabel is "dashboard", "quick upload", "reports"
              // or the child.label is "payment approval", "bids", or "directory"

              if (
                ["Dashboard", "Quick Uploads", "Reports"].includes(
                  moduleLabel
                ) ||
                ["Payment Approval", "Bids", "Directory"].includes(child.label)
              ) {
                // Do not change edit, delete, view, and create for these modules/children
                return {
                  ...child,
                  available: isChecked ? 1 : 0,
                  not_available: 0,
                  premium: 0,
                  coming_soon: 0,
                  web: child?.web !== 0 ? (isChecked ? 1 : 2) : 0,
                  mobile: child?.mobile !== 0 ? (isChecked ? 1 : 2) : 0,
                  full_access: isChecked ? 1 : 2,
                  // Keep view, create, edit, delete unchanged
                  view: child?.view,
                  create: child?.create,
                  edit: child?.edit,
                  delete: child?.delete,
                  excel: child?.excel !== 0 ? (isChecked ? 1 : 2) : 0,
                  pdf: child?.pdf !== 0 ? (isChecked ? 1 : 2) : 0,
                  template_no: "",
                };
              } else {
                // Default behavior for other modules/children
                return {
                  ...child,
                  available: isChecked ? 1 : 0,
                  not_available: 0,
                  premium: 0,
                  coming_soon: 0,
                  web: child?.web !== 0 ? (isChecked ? 1 : 2) : 0,
                  mobile: child?.mobile !== 0 ? (isChecked ? 1 : 2) : 0,
                  full_access: isChecked ? 1 : 2,
                  view: child?.view !== 0 ? (isChecked ? 1 : 2) : 0,
                  create: child?.create !== 0 ? (isChecked ? 1 : 2) : 0,
                  edit: child?.edit !== 0 ? (isChecked ? 1 : 2) : 0,
                  delete: child?.delete !== 0 ? (isChecked ? 1 : 2) : 0,
                  excel: child?.excel !== 0 ? (isChecked ? 1 : 2) : 0,
                  pdf: child?.pdf !== 0 ? (isChecked ? 1 : 2) : 0,
                  template_no: "",
                };
              }
            }),
          };
        }
        return module;
      })
    );
  };

  const handleInputChange = (moduleId, childId, value) => {
    setRoleModules((prevModules) =>
      prevModules.map((module) => {
        if (module._id === moduleId) {
          return {
            ...module,
            children: module.children.map((child) => {
              if (child._id === childId) {
                return { ...child, template_no: value };
              }
              return child;
            }),
          };
        }
        return module;
      })
    );
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const modalOpenCloseHandler = (openClose_key, label, index, child_id) => {
    if (open?.label === label && open?.index === index) {
      setOpen({ key: false, label: "", index: -1 });
    } else {
      if (child_id != paymentApvObjectId) {
        setOpen({ key: openClose_key, label, index });
      } else {
        setIsPaymentApproval(true)
      }
    }
  };

  useEffect(() => {
    if (roleModules?.length > 0) {
      let newArray = roleModules?.find((el) => el?._id === moduleObjectId)?.children?.find((child) => child?._id === paymentApvObjectId)?.more_permissions
      setPaymentApproval(newArray);

      if (roleModules?.find((el) => el?._id === moduleObjectId)?.children?.find((child) => child?._id === paymentApvObjectId)?.available == 1) {
        setIsPaymentApproval(true)
      } else {
        setIsPaymentApproval(false)
      }
    }
  }, [roleModules])

  const handlePaymentApprovalChange = (index, key, value) => {
    setPaymentApproval(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [key]: value };
      return updated;
    });

    let approvalArray = [...paymentApproval];
    approvalArray[index] = { ...approvalArray[index], [key]: value };

    setRoleModules((prevModules) =>
      prevModules.map((module) => {
        if (module._id === moduleObjectId) {
          return {
            ...module,
            children: module.children.map((child) => {
              if (child._id === paymentApvObjectId) {
                return { ...child, more_permissions: approvalArray };
              }
              return child;
            }),
          };
        }
        return module;
      })
    );
  };

  useEffect(() => {
    if (!isPaymentApproval) {
      setRoleModules((prevModules) =>
        prevModules.map((module) => {
          if (module._id === moduleObjectId) {
            return {
              ...module,
              children: module.children.map((child) => {
                if (child._id === paymentApvObjectId) {
                  return { ...child, more_permissions: utils.paymentApprovalArray };
                }
                return child;
              }),
            };
          }
          return module;
        })
      );
    }
  }, [isPaymentApproval])


  return (
    <>
      <div className="__madCont_bx" >
        <div className="__inrFxl_cnt">
          <div className="_otrRl_table">
            {roleModules?.map((module, ind) => {
              const isFullAccessForAllChildren = module?.children?.some(
                (child) => {
                  const hasAnyPermission =
                    child.view == 1 ||
                    child.create == 1 ||
                    child.edit == 1 ||
                    child.delete == 1 ||
                    child.web == 1 ||
                    child.mobile == 1;

                  const isExcel =
                    module?.label === "Reports" ? child.excel === 1 : false;
                  const isPdf =
                    module?.label === "Reports" ? child.pdf === 1 : false;

                  return hasAnyPermission || isExcel || isPdf;
                }
              );

              return (
                <>
                  <div className="_mainRl_table" key={ind}>
                    <div className="_addRl_headCheck">
                      <input
                        type="checkbox"
                        label="Dashboard"
                        id={`parent_checkbox_${module._id}`}
                        checked={isFullAccessForAllChildren}
                        disabled={isViewPage}
                        onChange={(e) =>
                          handleParentCheckbox(
                            module._id,
                            e.target.checked,
                            module.label
                          )
                        }
                      />
                      <label
                        htmlFor={`parent_checkbox_${module._id}`}
                        className="anvLabel"
                      >
                        {module?.label}
                      </label>
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Description</th>


                          <th>
                            <div className="_flRx_dl">
                              <div className="_TwTie">Web</div>
                              <div className="_TwTie">Mobile</div>
                            </div>
                          </th>
                          {module?.label === "Reports" ? (
                            <th>
                              <div className="_flRx_dl justify-content-start">
                                <div className="_TwTie inxEl">Excel</div>
                                <div className="_TwTie inxEl">PDF</div>
                              </div>
                            </th>
                          ) : module?.label === "Dashboard" ||
                            module?.label === "Quick Uploads" ? (
                            <th></th>
                          ) : (
                            <th>
                              <div className="_flRx_dl">
                                <div className="_fvTie">Full Access</div>
                                <div className="_fvTie">View</div>
                                <div className="_fvTie">Create</div>
                                <div className="_fvTie">Edit</div>
                                <div className="_fvTie">Delete</div>
                              </div>
                            </th>
                          )}

                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        {module?.children?.map((child, index) => {
                          const isAvailable = child.available === 1;
                          const isCheckboxDisabled =
                            !isAvailable ||
                            child.not_available === 1 ||
                            child.premium === 1 ||
                            child.coming_soon === 1;


                          const getText = (child) => {
                            if (child.available === 1) return "Available";
                            if (child.not_available === 1) return "Not available";
                            if (child.premium === 1) return "Premium";
                            if (child.coming_soon === 1) return "Coming soon";
                            return "";
                          };
                          return (
                            <tr key={`childIndex_${index}`}>
                              <td>
                                <div className="addRoleStatus">
                                  {child?.label}
                                  <span className={`__spn${getText(child) == "Coming soon" ? "coming_soon" : getText(child) == "Not available" ? "Not_available" : getText(child)}`}>

                                    <p> {getText(child)}</p>{" "}
                                  </span>
                                </div>
                                { } </td>



                              <td>
                                <div className="_flRx_dl">
                                  <div className="_TwTie">
                                    <input
                                      type="checkbox"
                                      name="web"
                                      id={`web_${child._id}`}
                                      disabled={child.web == 0 || isViewPage}
                                      checked={child.web === 1}
                                      onChange={(e) =>
                                        handleChange(
                                          module._id,
                                          child._id,
                                          "web",
                                          e.target.checked ? 1 : 2
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`web_${child._id}`}
                                      className="anvLabel"
                                    ></label>
                                  </div>

                                  <div className="_TwTie">
                                    <input
                                      type="checkbox"
                                      name="mobile"
                                      id={`mobile_${child._id}`}
                                      disabled={child.mobile == 0 || isViewPage}
                                      checked={child.mobile === 1}
                                      onChange={(e) =>
                                        handleChange(
                                          module._id,
                                          child._id,
                                          "mobile",
                                          e.target.checked ? 1 : 2
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`mobile_${child._id}`}
                                      className="anvLabel"
                                    ></label>
                                  </div>
                                </div>
                              </td>

                              {module?.label === "Dashboard" ||
                                module?.label === "Quick Uploads" ||
                                child?.label === "Payment Approval" ||
                                child?.label === "Directory" ||
                                child?.label === "Bids" ? (
                                <td></td>
                              ) : module?.label === "Reports" ? (
                                <td>
                                  <div className="_flRx_dl justify-content-start">
                                    {["excel", "pdf"].map((key) => (
                                      <div key={key} className="_TwTie inxEl">
                                        <input
                                          type="checkbox"
                                          name={key}
                                          id={`${key}_${child._id}`}
                                          disabled={child[key] === 0 || isViewPage}
                                          checked={child[key] === 1}
                                          onChange={(e) =>
                                            handleChange(
                                              module._id,
                                              child._id,
                                              key,
                                              e.target.checked ? 1 : 2
                                            )
                                          }
                                        />
                                        <label
                                          htmlFor={`${key}_${child._id}`}
                                          className="anvLabel"
                                        ></label>
                                      </div>
                                    ))}
                                  </div>
                                </td>
                              ) : (
                                <td>
                                  <div className="_flRx_dl">
                                    {[
                                      "full_access",
                                      "view",
                                      "create",
                                      "edit",
                                      "delete",
                                    ].map((key) => {
                                      const isFullAccessDisabled =
                                        key === "full_access" &&
                                        [
                                          "view",
                                          "create",
                                          "edit",
                                          "delete",
                                        ].every((perm) => child[perm] === 0);

                                      return (
                                        <div key={key} className="_fvTie">
                                          <input
                                            type="checkbox"
                                            name={key}
                                            id={`${key}_${child._id}`}
                                            disabled={
                                              (key === "full_access"
                                                ? isFullAccessDisabled
                                                : key === "view"
                                                  ? child["view"] === 0 || [
                                                    "edit",
                                                    "delete",
                                                    "create",

                                                  ].some(
                                                    (key) => child[key] == 1
                                                  )
                                                  : child[key] === 0) || isViewPage
                                            }
                                            checked={
                                              key === "full_access"
                                                ? [
                                                  "view",
                                                  "create",
                                                  "edit",
                                                  "delete",
                                                ].every(
                                                  (perm) => child[perm] === 1
                                                )
                                                : child[key] === 1
                                            }
                                            onChange={(e) =>
                                              handleChange(
                                                module._id,
                                                child._id,
                                                key,
                                                e.target.checked ? 1 : 2
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor={`${key}_${child._id}`}
                                            className="anvLabel"
                                          ></label>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </td>
                              )}

                              <td>
                                {child.premium === 1 && (
                                  <input
                                    type="number"
                                    className="form-control"
                                    maxLength="8"
                                    placeholder="Template No."
                                    onInput={maxLengthCheck}
                                    onFocus={(e) =>
                                      e.target.addEventListener(
                                        "wheel",
                                        function (e) {
                                          e.preventDefault();
                                        },
                                        { passive: false }
                                      )
                                    }
                                    value={child.template_no}
                                    onChange={(e) =>
                                      handleInputChange(
                                        module._id,
                                        child._id,
                                        e.target.value
                                      )
                                    }
                                  />
                                )}
                                {child?._id != paymentApvObjectId && (<>
                                  {child.more_permissions && child.more_permissions.length > 0 && (
                                    <div className="dropdown" ref={dropdownRef}>
                                      <button
                                        className="dropdown-toggle __dropDownBx"
                                        type="button"
                                        onClick={() => modalOpenCloseHandler(true, child?.label, index, child?._id)}
                                        aria-expanded={open}
                                      >
                                        More Permissions
                                      </button>

                                      <div className={`dropdown-menu${(open?.label === child?.label && open?.index === index) ? " show" : ""}`}>
                                        <ul style={{ listStyleType: "none", padding: 0, margin: 0, width: "200px", position: "relative" }} >
                                          <RiCloseFill style={{ position: "absolute", right: "0.5rem", top: "-1rem", cursor: "pointer" }}
                                            // onClick={()=>setOpen(false)}
                                            onClick={() => modalOpenCloseHandler(false, child?.label, index, child?._id)}
                                          />
                                          <div style={{ marginTop: "15px" }}>
                                            {child.more_permissions.map((perm, index) => {
                                              const inputId = `${perm.label.replace(/\s+/g, '_')}_${child._id}`;
                                              return (

                                                <li key={index} style={{ padding: "0px 0px 0px 5px ", display: "flex", alignItems: "center" }}>
                                                  <input
                                                    type="checkbox"
                                                    id={inputId}
                                                    checked={perm.is_enabled === 1}
                                                    disabled={perm.is_enabled === 0 || isViewPage}
                                                    // onChange={(e) =>
                                                    //   handlePermissionChange(child._id, index, e.target.checked)
                                                    // }
                                                    onChange={(e) =>
                                                      handlePermissionChange(
                                                        module._id,
                                                        child._id,
                                                        "more_permissions",
                                                        index,
                                                        e.target.checked ? 1 : 2
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={inputId}
                                                    style={{
                                                      display: "inline-flex",
                                                      marginBlock: "5px",
                                                      marginInline: "5px",
                                                    }}
                                                    className="anvLabel"
                                                  >
                                                    {perm.display_name || perm.label}
                                                  </label>
                                                </li>
                                              );
                                            })}
                                          </div>

                                        </ul>
                                      </div>
                                    </div>
                                  )}</>)}


                                {/* {child?.more_permissions && child?.more_permissions.length > 0 && (
                                                                    <div className="dropdown">
                                                                        <button
                                                                            className="dropdown-toggle __dropDownBx"
                                                                            type="button"
                                                                            onClick={() => modalOpenCloseHandler(true, child?.label, index, child?._id)}
                                                                            aria-expanded={true}
                                                                        >
                                                                            More Permissions
                                                                        </button>

                                                                        <div className={`dropdown-menu${(open?.label === child?.label && open?.index === index) ? " show" : ""}`}>
                                                                            <ul style={{ listStyleType: "none", padding: 0, margin: 0, width: "200px", position: "relative" }} >
                                                                                <RiCloseFill style={{ position: "absolute", right: "0.5rem", top: "-1rem", cursor: "pointer" }} onClick={() => modalOpenCloseHandler(false, child?.label, index)} />
                                                                                <div style={{ marginTop: "15px" }}>
                                                                                    {child.more_permissions.map((perm, index) => {
                                                                                        const inputId = `${perm.label.replace(/\s+/g, '_')}_${child._id}`;
                                                                                        return (

                                                                                            <li key={index} style={{ padding: "0px 0px 0px 5px ", display: "flex", alignItems: "center" }}>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={inputId}
                                                                                                    checked={perm.is_enabled === 1}
                                                                                                    // disabled={perm.is_enabled === 0}
                                                                                                    // onChange={(e) =>
                                                                                                    //   handlePermissionChange(child._id, index, e.target.checked)
                                                                                                    // }
                                                                                                    onChange={(e) =>
                                                                                                        handlePermissionChange(
                                                                                                            module._id,
                                                                                                            child._id,
                                                                                                            "more_permissions",
                                                                                                            index,
                                                                                                            e.target.checked ? 1 : 2
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    htmlFor={inputId}
                                                                                                    style={{
                                                                                                        display: "inline-flex",
                                                                                                        marginBlock: "5px",
                                                                                                        marginInline: "5px",
                                                                                                    }}
                                                                                                    className="anvLabel"
                                                                                                >
                                                                                                    {perm.display_name || perm.label}
                                                                                                </label>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </div>

                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                )} */}

                              </td>

                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              );
            })}
            {isPaymentApproval ? <div className='_mainRl_table'>
              <table>
                <thead>
                  <tr>
                    <th> Payment Approvals </th>
                  </tr>
                </thead>

                <tbody>
                  {
                    paymentApproval?.map((element, index) => {
                      const permissionKeys = ["approve", "on_hold", "reject", "complete", "payment_from_cb", "initiate_with_bank"];

                      return (
                        <tr key={index}>
                          <td>{element?.display_name}</td>
                          <td>
                            {!element?.message ? (
                              <div className='_flRx_dl' style={{ justifyContent: 'flex-start' }}>
                                {permissionKeys.map((key) =>
                                  key in element ? (
                                    <>
                                      <div className="_fvTie" style={{ flex: '0 0 calc(18% - 28px)' }}>
                                        <input
                                          type="checkbox"
                                          name={key}
                                          id={`${element?.display_name}_${key}_${index}`}
                                          checked={element[key] === 1}
                                          disabled={element[key] === 0 || isViewPage}
                                          onChange={(e) => {
                                            const updatedValue = e.target.checked ? 1 : 2;
                                            handlePaymentApprovalChange(index, key, updatedValue);
                                          }}
                                        />
                                        <label
                                          style={{ overflow: 'inherit', display: 'block', paddingLeft: '1.6em', width: '100%', textAlign: 'left' }}
                                          htmlFor={`${element?.display_name}_${key}_${index}`}
                                          className="anvLabel"
                                        > {utils.firstLetterCapital(key.replace("_", " "))} </label>

                                      </div>
                                    </>
                                  ) : null
                                )}
                              </div>
                            ) : (
                              <span>{element?.message}</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </div> : <></>}




          </div>
        </div>
      </div>
    </>
  );
};

export default NewRole;
